import React from "react";
import { connect } from "react-redux";

import { Card, CardBody, Row, Col } from "reactstrap";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemButton,
} from 'react-accessible-accordion';

const AcordeonCondiciones = (props) =>
  <Card className="flex-row">
    <CardBody>
      <Row>
        <Col lg={12} md={12} sm={12} xs={12}>
          <Accordion allowZeroExpanded="true">
            {props.terminosCondiciones !== undefined
              && props.terminosCondiciones.map((data, i) =>
                <AccordionItem key={`data${i}`}>
                  <AccordionItemHeading>
                    <AccordionItemButton className="accordion-button-Responsabilidad">
                      {data.descripcion}
                    </AccordionItemButton>
                  </AccordionItemHeading>
                  <AccordionItemPanel>
                  <div style={{ textAlign: "justify", }}>
                    <ul>
                      {data.detalle !== undefined
                        && data.detalle.map((detalle, i) =>
                        <li  key={`detalle${i}`}>{detalle}</li>
                      )}
                    </ul> 
                  </div>
                  </AccordionItemPanel>
                </AccordionItem>
              )
            }
          </Accordion>
        </Col>
      </Row>
    </CardBody>
  </Card>

const mapStateToProps = state => ({
});
const mapDispatchToProps = dispatch => {
  return {
  };
};
export default
  connect(
    mapStateToProps,
    null
  )(AcordeonCondiciones)
